/* eslint-disable */
import axios from 'axios'
import router from '../../router';
import store from '@/plugins/store.js'
import { setUser, getUser } from '../../assets/js/common';

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_ROOT,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json'
  },
  cache: false
});

const getAuthToken = () => localStorage.getItem("key");

const authInterceptor = (config) => {
  config.headers['Authorization'] = "Bearer " + getAuthToken();
  return config;
}

const responseInterceptor = response => {
  switch(response.status) {
      case 200: 
          // yay!
          if (response.config.url === "/authen/login") {
            if (response.data.status == 1) {
              setUser(response.data.data);
            } 
            store.commit("setUser", getUser());
            return response.data;
          }
          break;
      // any other cases
      default:
          // default case
  }
  return response.data;
}

const errorInterceptor = error => {
  console.log("errorInterceptor");
  if (error.config.url == process.env.VUE_APP_SERVICE_ROOT + "/authen/login") {
      console.log('show login page');
      return Promise.reject(error);
  }

  if (!error.response) {
      console.log('show error page');
      router.push({ name: 'error', params: { errorMessage: error} });
      return;
  }

  // all the error responses
  switch(error.response.status) {
      case 401: // authentication error, logout the user
        {
          localStorage.removeItem('key');
          router.push("login");
          //this.$loading(true);
          //window.location = "/";
          break;
        }
      default:
          console.error(error.response);
          router.push({ name: 'error', params: {
             errorMessage: error.response.data.error.message,
             url: error.response.config.url
            } });
          break;
  }
  return Promise.reject(error);
}

HTTP.interceptors.request.use(authInterceptor);
HTTP.interceptors.response.use(responseInterceptor, errorInterceptor);

export default HTTP;